import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationsChannelStore = defineStore('notificationsChannel', () => {
  const socketRef = ref<number>()
  const topic = ref<string>()
  return { socketRef, topic }
})
